<template>
  <div
    class="sidebar"
    :style="sidebarStyle"
    :data-color="backgroundColor"
    :data-image="backgroundImage"
  >
    <div class="sidebar-wrapper">
      <div class="logo">
        <a
          href="#"
          class="simple-text logo__container text-capitalize animate__animated animate__bounce"
        >
          <div class="pr-2">
            <img src="img/logo.png" alt="" width="60px" />
          </div>
          {{ title }}
        </a>
      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <SidebarLink
          v-for="(i, index) in navigationsList"
          :key="index"
          :menu="i"
          class="animate__animated animate__backInLeft"
        ></SidebarLink>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
import SidebarLink from "@/views/layout/sideBar/SidebarLink.vue";
import { navigationList } from "@/core/services";
import { jwtHelper } from "@/core/utils";

export default {
  components: {
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: "DevOps Portal",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = [
          "",
          "blue",
          "azure",
          "green",
          "orange",
          "red",
          "purple",
          "black",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: "img/sidebar-5.jpg",
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  data: () => ({
    navigationsList: null,
    permission: null,
  }),
  created() {
    this.getProfile();
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
  },
  methods: {
    getProfile() {
      let profile = jwtHelper.getProfile();
      this.permission = profile.permission.modules;
      this.getMenuListing();
    },
    getMenuListing() {
      let menu = [];
      let permissions = this.permission;

      navigationList.forEach(function ($v) {
        let child = typeof $v.children;

        if (child == "undefined" && $v.authPermissionModule == "") {
          menu.push($v);
        } else if (child == "undefined" && $v.authPermissionModule != "") {
          permissions.forEach(function (p) {
            if (p == $v.authPermissionModule) {
              menu.push($v);
            }
          });
        } else if (child != "undefined") {
          let childs = $v.children;
          let childmenu = [];

          childs.forEach(function ($c) {
            permissions.forEach(function (p) {
              if (p == $c.authPermissionModule) {
                childmenu.push($c);
              }
            });
          });

          if (childmenu.length > 0) {
            $v.children = childmenu;
            menu.push($v);
          }
        }
      });

      this.navigationsList = menu;
    },
  },
};
</script>
<style>
.sidebar .sidebar-wrapper {
  display: flex;
  flex-direction: column;
}
.sidebar .nav-main__links {
  flex: 1;
}
.sidebar .sidebar-wrapper .logo .logo__container {
  padding-left: 10px;
}
</style>
